import React, { useEffect } from 'react'
import { FormWrapper, Head } from '../../component'
import { TrackPageViewed } from '../../integrations/amplitude'
import { ConsumerPage } from '../../model'
import { Route } from '../../config/router'
import { Heading, Loader, Theme, useIsTheme } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import { useConsumerEmail, useConsumerFeatureFlagReady, useConsumerName, useAppRouter, useConsumerSelector } from '../../state'
import { ProfileCard } from '../../component/ProfileCard'
import { useConsumerSizes } from '../../utils/responsive'
import { useLoggedInRedirect } from '../../hooks/useLoggedInRedirect'
import { getLoggedInLoadingMessages } from './helper'

export const LoggedInPage: ConsumerPage = () => {
  const { t } = useTranslation()
  const pageTitle = `${t('common:brandName')}`
  const { loggedInLoadingMessageKey } = useConsumerSelector()
  const isCashTheme = useIsTheme(Theme.Cash)
  const consumerName = useConsumerName()
  const consumerEmail = useConsumerEmail()
  const { headingSize } = useConsumerSizes()
  const testNameSpace = 'logged-in'
  const { title: loadingTitle, description: loadingDescription } = getLoggedInLoadingMessages(t, loggedInLoadingMessageKey ?? undefined)

  const hasFeatureFlagsReady = useConsumerFeatureFlagReady()
  const router = useAppRouter()

  useEffect(() => {
    router.prefetch(Route.HOME)
    router.prefetch(Route.VERIFY_IDENTITY)
    router.prefetch(Route.VERIFY_RETRY)
  }, [])

  const { loggedInRedirect } = useLoggedInRedirect()

  useEffect(() => {
    if (hasFeatureFlagsReady) {
      loggedInRedirect()
    }
  }, [hasFeatureFlagsReady])

  if (isCashTheme) {
    return (
      <>
        <Head title={pageTitle} />
        <Loader alignCenter text={loadingDescription} />
        <TrackPageViewed />
      </>
    )
  }
  return (
    <>
      <Head title={pageTitle} />
      {loggedInLoadingMessageKey != null && loggedInLoadingMessageKey !== '' && (
        <Heading testNameSpace={testNameSpace} size={headingSize}>
          {loadingTitle}
        </Heading>
      )}
      <FormWrapper>
        <div className='mb-4 mt-4'>
          <ProfileCard consumerName={consumerName} consumerEmail={consumerEmail ?? ''} />
        </div>
        <Loader text={loadingDescription} testNameSpace={testNameSpace} />
      </FormWrapper>
      <TrackPageViewed eventProps={{ loggedInLoadingMessageKey }} />
    </>
  )
}
